const moduleMap = {
	"./App": () => {
		return Promise.all([__webpack_require__.e(423), __webpack_require__.e(862), __webpack_require__.e(698), __webpack_require__.e(914)]).then(() => (() => ((__webpack_require__(5766)))));
	},
	"./NavigationConfig": () => {
		return __webpack_require__.e(172).then(() => (() => ((__webpack_require__(4172)))));
	}
};
const get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
const init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	const name = "default"
	const oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});